/* src/app/main-layout/footer/footer.component.css */
@layer properties;
img {
  width: calc(var(--spacing, 0.25rem) * 20);
}
footer {
  background-color: #e2e8e5;
}
@media (width <= 991px) {
  footer {
    position: fixed;
    right: calc(var(--spacing, 0.25rem) * 0);
    bottom: calc(var(--spacing, 0.25rem) * 0);
    left: calc(var(--spacing, 0.25rem) * 10);
    z-index: 4;
  }
}
.brand {
  display: flex;
  align-items: center;
  padding-inline: calc(var(--spacing, 0.25rem) * 5);
}
@media (width >= 80rem) {
  .brand {
    padding-inline: calc(var(--spacing, 0.25rem) * 10);
  }
}
.footer-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: calc(var(--spacing, 0.25rem) * 3);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
}
@media (width >= 48rem) {
  .footer-bar {
    justify-content: space-between;
  }
}
@media (width >= 64rem) {
  .footer-bar {
    padding-block: calc(var(--spacing, 0.25rem) * 4);
  }
}
.brand-link {
  display: inline-block;
  height: 100%;
  text-decoration-line: none;
}
.brand-logo {
  display: block;
}
.link-default:hover {
  color: var(--color-black, #000);
}
.footer-address-data {
  display: none;
  align-items: flex-start;
}
@media (width >= 48rem) {
  .footer-address-data {
    display: flex;
  }
}
.footer-cell {
  padding-inline: calc(var(--spacing, 0.25rem) * 5);
}
@media (width >= 80rem) {
  .footer-cell {
    padding-inline: calc(var(--spacing, 0.25rem) * 10);
  }
}
@media screen and (width >= 992px) {
  .footer-address-data {
    font-size: 0.65rem;
    --tw-leading: 1.35;
    line-height: 1.35;
  }
}
@property --tw-leading { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-leading: initial;
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=footer.component.css.map */
